export default __webpack_public_path__ + "a5393a358f411b8a6d015c49975c08f8.png";